import { sirenActions, useSirenEntity, useStoreValues } from '~/runtime';

export default function useOrganizationDescendantsSearchHref({ limit = 0, organizationTypes = [], intent, baseOrganizationHref, summary = true }) {
  const { rootOrganizationHref } = useStoreValues(['rootOrganizationHref']);
  const { entity: rootOrg } = useSirenEntity({ href: baseOrganizationHref || rootOrganizationHref });
  const { entity: searchEntity } = useSirenEntity({ href: rootOrg?.getLinkByRel('https://api.binsentry.com/rel/search-organizations')?.href });

  const orgTypeSet = new Set(organizationTypes);
  const useTypeFilter = orgTypeSet.size > 0;
  const useIntentFilter = !!intent;
  const anyFilter = useTypeFilter || useIntentFilter;

  let finalFilter = searchEntity;

  let typeFilteredHref;
  if (finalFilter && useTypeFilter) {
    const { url: typeFilteredUrl } = sirenActions.parseAction(
      finalFilter.getAction('update-organization-types-filter'),
      { organizationTypeName: [...orgTypeSet] },
      { appendArrays: true, includeDefaults: false },
    );
    typeFilteredHref = typeFilteredUrl.href;
  }
  const { entity: typeFilteredEntity } = useSirenEntity({ href: typeFilteredHref });
  if (useTypeFilter) {
    finalFilter = typeFilteredEntity;
  }

  let intentFilteredHref;
  if (finalFilter && useIntentFilter) {
    const { url: intentFilteredUrl } = sirenActions.parseAction(
      finalFilter.getAction('update-organization-intent-filter'),
      { intent },
      { includeDefaults: false },
    );
    intentFilteredHref = intentFilteredUrl.href;
  }
  const { entity: intentFilteredEntity } = useSirenEntity({ href: intentFilteredHref });
  if (useIntentFilter) {
    finalFilter = intentFilteredEntity;
  }

  if (!anyFilter || !finalFilter) {
    return {};
  }

  const { url } = sirenActions.parseAction(
    finalFilter.getAction('search-organizations'),
    {
      sort: 'name',
      query: '',
      summary,
      limit,
    },{
      includeDefaults: false,
    },
  );
  return { searchHref: url?.href };
}
